// oxlint-disable-next-line no-restricted-imports -- TODO(zod-4): migrate to 'zod/v4'
import { z } from 'zod';

import type { SelectMembersAndTeamsOption } from '#components/Approvals/components/RequestApprovalButton/SelectMembersAndTeams';

export const createApprovalFormSchema = ({ minNumApprovals }: { minNumApprovals: number }) =>
  z
    .object({
      reason: z.string().min(1),
      reviewers: z
        .array(
          z.custom<SelectMembersAndTeamsOption>(
            (val) =>
              val !== null &&
              typeof val === 'object' &&
              ['member', 'team'].includes(val.kind) &&
              typeof val.value === 'string',
          ),
        )
        .min(minNumApprovals, 'Reviewers are required'),
    })
    .passthrough();

export const commentFormSchema = z
  .object({
    comment: z.string().optional(),
  })
  .passthrough();

export type ApprovalFormSchema = z.infer<ReturnType<typeof createApprovalFormSchema>>;
export type CommentFormSchema = z.infer<typeof commentFormSchema>;
